import { useSelector } from 'react-redux';

/**
 * Checks the redux store to determine whether the user has been authenticated
 * or not.
 *
 * @returns {Boolean} Whether the user is authenticated or not.
 */
const useAuthenticated = () => {
  return useSelector(({ auth }) => auth.authenticated);
};

export default useAuthenticated;
